/**
 * The gathering cover document — the same shape clubs (`clubCoverModel.coverFromClub`) and Pro
 * pages keep, fed from GatheringSummaryDto / GatheringDetailDto, plus the API adapter that lets
 * the one `ProCoverEditor` save through the gathering endpoints. No fake event id anywhere: the
 * owner is the gathering.
 */
import gatheringService from '../../services/gatheringService';
import { DEFAULT_RATIO } from '../event/coverLayout';

const num = (v, fallback = 50) => {
  const n = Number(v);
  return Number.isFinite(n) ? Math.max(0, Math.min(100, n)) : fallback;
};

/** Photos in cover order with framing, the saved layout / split / count and the card pick. */
export function coverFromGathering(g, ratios = {}) {
  const photos = (g?.photos || []).map((p, i) => ({
    id: p.id || `p${i}`, src: p.url, path: p.path, r: ratios[p.url] || DEFAULT_RATIO, measured: !!ratios[p.url],
    fx: num(p.focalX), fy: num(p.focalY),
  }));
  return {
    photos,
    layout: g?.coverLayout || 'auto',
    split: [60, 50, 40].includes(Number(g?.coverSplit)) ? Number(g.coverSplit) : 60,
    count: Number(g?.coverPhotoCount || 0),
    cardId: g?.cardPhotoId || null,
  };
}

/** The photos that make the cover: the first `count` (all when unset). */
export function coverSlice(cover) {
  const n = cover.photos.length;
  if (!n) return [];
  const k = cover.count > 0 ? Math.min(cover.count, n) : n;
  return cover.photos.slice(0, k);
}

/** What `ProCoverEditor` calls, pointed at one gathering. No cover video on gatherings. */
export const gatheringCoverApi = (gatheringId) => ({
  updateCover: (payload) => gatheringService.updateCover(gatheringId, payload),
  uploadAsset: (file) => gatheringService.uploadCoverPhoto(gatheringId, file),
  video: null,
});

/** The editor's gathering wording. */
export const GATHERING_COVER_COPY = {
  intro: 'The gathering’s name, dates and host sit on the left. Drag any photo on the cover to choose what stays in frame.',
  cardNote: 'Order sets which photo goes where. The CARD photo is the one people see on the gathering’s row under the club and on your host dashboard.',
  pageWord: 'gathering',
};
